import { helpers } from 'vuelidate/lib/validators'

export const exactLength = param => helpers.withParams(
  { type: 'exactLength', value: param },
  (value) => {
    if(value) {
      return helpers.len(value) === param
    }
    return false
  }
)

export const cadastreNumber = helpers.withParams(
    { type: 'cadastreNumber' },
    (value) => {
        if(value) {
            return helpers.len(value) === 15 // ##:##:#########
                || helpers.len(value) === 19 // ##:##:##:##:##:####
                || helpers.len(value) === 20 // ##:##:##:##:##:#####
                || helpers.len(value) === 22 // ##:##:##:##:##:####/##
                || helpers.len(value) === 23 // ##:##:##:##:##:#####/##
                || helpers.len(value) === 24 // ##:##:##:##:##:####:####
                                             // ##:##:##:##:##:####/####
                || helpers.len(value) === 25 // ##:##:##:##:##:#####/####
                || helpers.len(value) === 28 // ##:##:##:##:##:####:####:###
        }
        return false
    }
)

export const phoneNumber = helpers.withParams(
  { type: 'phoneNumber' },
  (value) => value ? helpers.len(value) === 19 : false
)

export const location = helpers.withParams(
    { type: 'location' },
    (value) => !!value
)

export const tinNumber = param => helpers.withParams(
    { type: 'tinLength' },
    (value) => {
        if(param) {
            return true
        }
        else {
            if(value) {
                return helpers.len(value) === 9
            }
            return false
        }
    }
)

export const customPassword = helpers.withParams(
    { type: 'customPassword' },
    (value) => {
        if(value) {
            let result = true
            result = result && /[A-Z]/.test(value)
            result = result && /[a-z]/.test(value)
            result = result && /\d/.test(value)
            result = result && /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?`~]/.test(value)
            return result
        }
        return false
    }
)

export default {exactLength, phoneNumber, cadastreNumber, tinNumber, customPassword}



